import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './login';
import Home from './Home';
import Register from './Register';
import Dashboard from './Components/Dashboard';
import AttendanceToday from './Components/AttendanceToday';
import AttendanceAdjustments from './Components/AttendanceAdjustments';
import AbsencesBoard from './Components/AbsencesBoard';
import OvertimeBoard from './Components/OvertimeBoard';
import EmployeesTable from './Components/EmployeesTable';
import EmployeeForm from './Components/EmployeeForm';
import UsersList from './Components/UsersList';
import UserManageForm from './Components/UserManageForm';
import WorkSchedulesList from './Components/WorkSchedulesList';
import WorkScheduleForm from './Components/WorkScheduleForm';
import DepartmentsList from './Components/DepartmentsList';
import DepartmentForm from './Components/DepartmentForm';
import ReportsPresences from './Components/ReportsPresences';
import ReportsAbsences from './Components/ReportsAbsences';
import { getAuthUser } from './utils/auth';

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const authUser = getAuthUser();
  const isEmployee = authUser?.role === 'EMPLOYEE';

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsLoggedIn(true);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('token');
    if (tokenFromUrl) {
      localStorage.setItem('token', tokenFromUrl);
      setIsLoggedIn(true);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={isLoggedIn ? <Navigate to="/home" /> : <Login setIsLoggedIn={setIsLoggedIn} />}
        />
        <Route
          path="/home"
          element={isLoggedIn ? <Home setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/" />}
        >
          <Route index element={isEmployee ? <Navigate to="/home/asistencia" /> : <Dashboard />} />
          <Route path="asistencia" element={<AttendanceToday />} />
          <Route path="ajustes" element={isEmployee ? <Navigate to="/home/asistencia" /> : <AttendanceAdjustments />} />
          <Route path="ausencias" element={<AbsencesBoard />} />
          <Route path="horas-extras" element={<OvertimeBoard />} />
          <Route
            path="perfil"
            element={isEmployee ? <UserManageForm profileMode /> : <Navigate to="/home/usuarios" />}
          />
          <Route path="empleados" element={isEmployee ? <Navigate to="/home/asistencia" /> : <EmployeesTable />} />
          <Route path="empleados/nuevo" element={isEmployee ? <Navigate to="/home/asistencia" /> : <EmployeeForm />} />
          <Route path="empleados/editar/:id" element={isEmployee ? <Navigate to="/home/asistencia" /> : <EmployeeForm />} />
          <Route path="usuarios" element={isEmployee ? <Navigate to="/home/asistencia" /> : <UsersList />} />
          <Route path="usuarios/nuevo" element={isEmployee ? <Navigate to="/home/asistencia" /> : <UserManageForm />} />
          <Route path="usuarios/editar/:id" element={isEmployee ? <Navigate to="/home/asistencia" /> : <UserManageForm />} />
          <Route path="departamentos" element={isEmployee ? <Navigate to="/home/asistencia" /> : <DepartmentsList />} />
          <Route path="departamentos/nuevo" element={isEmployee ? <Navigate to="/home/asistencia" /> : <DepartmentForm />} />
          <Route path="departamentos/editar/:id" element={isEmployee ? <Navigate to="/home/asistencia" /> : <DepartmentForm />} />
          <Route path="informes/presencias" element={isEmployee ? <Navigate to="/home/asistencia" /> : <ReportsPresences />} />
          <Route path="informes/ausencias" element={isEmployee ? <Navigate to="/home/asistencia" /> : <ReportsAbsences />} />
          <Route path="horarios" element={isEmployee ? <Navigate to="/home/asistencia" /> : <WorkSchedulesList />} />
          <Route path="horarios/nuevo" element={isEmployee ? <Navigate to="/home/asistencia" /> : <WorkScheduleForm />} />
          <Route path="horarios/editar/:id" element={isEmployee ? <Navigate to="/home/asistencia" /> : <WorkScheduleForm />} />
        </Route>
        <Route
          path="/register"
          element={isLoggedIn ? <Navigate to="/home" /> : <Register />}
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}
